module.exports = __webpack_public_path__ + "static/media/creator-NickJenkins.106b280b.png";